import { useEffect } from 'react';
import { useAuth } from '../auth/AuthProvider';
import { useHealth } from '../lib/useHealth';
import { EMBEDDED_BUILD_ID } from '../pwa/version';
import { registerApp, setUser } from './context';

/**
 * Pont entre l'app et le module de diagnostic : publie l'utilisateur actif (id +
 * rôle, métadonnées) et les informations statiques (version + hôte via
 * `/api/health`, `buildId` du bundle). Ne rend rien.
 *
 * Aucune donnée sensible : ni e-mail, ni nom affiché, seulement l'`id` structurel
 * et le rôle (utile pour reproduire un problème de permissions).
 */
export function DiagnosticsBridge(): null {
  const { user } = useAuth();
  // Source PARTAGÉE de `/api/health` (cf. `useHealth`) : ce pont ne déclenche plus
  // sa propre requête, il s'abonne à celle de l'app.
  const { health } = useHealth();

  // Utilisateur courant → contexte (recalculé à chaque changement d'identité).
  useEffect(() => {
    setUser(user ? { id: user.id, role: user.role } : null);
  }, [user]);

  // Le buildId vient du bundle (build client réellement en cours d'exécution).
  useEffect(() => {
    registerApp({ buildId: EMBEDDED_BUILD_ID === 'dev' ? null : EMBEDDED_BUILD_ID });
  }, []);

  // Version + hôte dès que `/api/health` a répondu. Health injoignable : on garde
  // les valeurs par défaut, non bloquant.
  useEffect(() => {
    if (health) registerApp({ version: health.version, hostname: health.publicHostname });
  }, [health]);

  return null;
}
